const ACTIONS = {
  LOAD_TRACK: 'PLAYBACK:LOAD_TRACK',
  SET_STATION: 'PLAYBACK:SET_STATION',
  SET_VOLUME: 'PLAYBACK:SET_VOLUME',
  TOGGLE_MUTE: 'PLAYBACK:TOGGLE_MUTE',
};

export default ACTIONS;
